// extracted by mini-css-extract-plugin
export default {"modalOverlay":"style_modalOverlay__vpzRd"};